(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.cart-page__qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', this.onThumbClick.bind(this));
      }, this);

      document.addEventListener('theme:variant:change', this.onVariantChange.bind(this));
    }

    setActive(mediaId) {
      if (!mediaId) return;

      var targets = this.querySelectorAll('[data-media-id="' + mediaId + '"]');
      if (!targets.length) return false;

      this.querySelectorAll('[data-media-id]').forEach(function (element) {
        element.classList.toggle('is-active', element.dataset.mediaId === String(mediaId));
      });

      return true;
    }

    onThumbClick(event) {
      this.setActive(event.currentTarget.dataset.mediaId);
    }

    onVariantChange(event) {
      this.setActive(event.detail.variant.mediaId);
    }
  }

  customElements.define('product-gallery', ProductGallery);

  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      var target = document.querySelector(this.dataset.target);
      if (!target) {
        this.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(this.onIntersect.bind(this));
      observer.observe(target);

      document.addEventListener('theme:variant:change', this.onVariantChange.bind(this));
    }

    onIntersect(entries) {
      this.classList.toggle('is-visible', !entries[0].isIntersecting);
    }

    onVariantChange(event) {
      var variant = event.detail.variant;
      var button = this.querySelector('[data-sticky-add-to-cart]');
      var text = this.querySelector('[data-sticky-add-to-cart-text]');
      var price = this.querySelector('[data-sticky-price]');

      button.disabled = !variant.available;
      text.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
      price.textContent = variant.priceFormatted;
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.testimonials__track');
      this.querySelectorAll('[data-direction]').forEach(function (button) {
        button.addEventListener('click', this.onNavClick.bind(this));
      }, this);
    }

    onNavClick(event) {
      var direction = Number(event.currentTarget.dataset.direction);
      var card = this.track.firstElementChild;
      var amount = card ? card.getBoundingClientRect().width + 26 : this.track.clientWidth;

      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }
  }

  customElements.define('testimonial-carousel', TestimonialCarousel);

  } catch(e) { console.error(e); }
})();
})();
